import { Select } from 'antd';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { mapProjectionList, MapProjection } from '~/common/typescript/services/map_projection/MapProjection';

export interface ProjectionSelection {
  srs: string;
  srs_name: string;
}

export interface ProjectionSelectorProps {
  defaultValue?: ProjectionSelection;
  onChange: (value: ProjectionSelection) => void;
  disabled?: boolean;
}

const ProjectionSelector = (props: ProjectionSelectorProps) => {
  const { t } = useTranslation();

  const options = mapProjectionList.map(p => ({
    label: p.name,
    value: p.name,
  }));

  const onChange = (value: string) => {
    if (props.onChange) {
      const selectedProjection = mapProjectionList.find(p => p.name === value);
      if (selectedProjection) {
        props.onChange({
          srs: selectedProjection.proj,
          srs_name: selectedProjection.name
        });
      }
    }
  };

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <Select
      showSearch
      placeholder={t('select_a_projection')}
      optionFilterProp="children"
      onChange={onChange}
      filterOption={filterOption}
      options={options}
      value={props.defaultValue?.srs_name}
      style={{ width: '100%' }}
      disabled={props.disabled}
    />
  );
};

export default memo(ProjectionSelector);
